const LOGO_URL = "https://customer-assets.emergentagent.com/job_mindmap-expedition/artifacts/3mn6qxhw_icon%20final.png";

export const Logo = ({ size = 44, withWordmark = true, dark = false }) => {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Mind Map compass rose logo"
        width={size}
        height={size}
        className="rounded-lg"
        style={{ width: size, height: size, objectFit: "contain" }}
      />
      {withWordmark && (
        <div className="leading-tight">
          <div
            className={`font-heading font-black tracking-tight ${dark ? "text-white" : "text-mm-navy"}`}
            style={{ fontSize: size > 36 ? 24 : 20 }}
          >
            Mind Map
          </div>
          <div
            className="font-body font-medium"
            style={{ fontSize: 11, color: dark ? "#CFE0EA" : "#5B8FA8", letterSpacing: "0.04em" }}
          >
            by The Meadows Mindset
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
